import { render, staticRenderFns } from "./TableByBets.vue?vue&type=template&id=7fd1c4ed&scoped=true"
import script from "./TableByBets.vue?vue&type=script&lang=js"
export * from "./TableByBets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd1c4ed",
  null
  
)

export default component.exports